import gql from 'graphql-tag';

export const findDispositivos = gql`
    query findDispositivos{
        findDispositivos {
            uuid
            nombre
            descripcion
    }
}`
